import React, {Component} from 'react';
import {Col, FormGroup, Form, ControlLabel, Checkbox, Radio, Row} from "react-bootstrap";
import ReactNotify from 'react-notify';
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import moment from "moment";
import {TopInputDate} from "../../../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import TopDostepnosc from "../../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import {TopAlertInformacja, TopAlertOstrzezenie, TopAlertSukces, TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import RozkladService from "../../RozkladService";


export default class GenerujRozkladForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyZakresDat: true,
            czyKonkretnaGodzina: false,

            czyByloSzukanie: false,

            trasa: null,

            dataOd: moment(),
            dataDo: moment(),

            godzina: null,

            response: null,


        };

    }

    componentDidMount() {
    }

    componentWillReceiveProps(np) {
    }

    onChangeTrasa(e) {
        this.setState({trasa: e, czyByloSzukanie: false, godzina: null})
        if (e !== null && Boolean(this.state.dataOd)) {
            this.props.handleSzukajGodzin(e, this.state.dataOd)
        }
    }

    onChangePojedynczaData(e) {
        if (e !== null && Boolean(this.state.trasa)) {
            this.props.handleSzukajGodzin(this.state.trasa, e)
        }
        this.setState({
            dataOd: e, dataDo: e, czyByloSzukanie: false, godzina: null
        });


    }


    onClickGeneruj() {

        this.setState({response: null})

        if (!Boolean(this.state.trasa) || !Boolean(this.state.dataOd) || !Boolean(this.state.dataDo)) {
            alert("Trasa oraz data bądź zakres dat muszą być uzupełnione!")
        }
        else {

            if (this.state.czyKonkretnaGodzina) {
                if (!Boolean(this.state.godzina)) {
                    alert("W przypadku generowania rozkładu dla danej godziny należy wybrać ów godzinę")
                }
                else {
                    console.log(
                        this.state.trasa.idTr,
                        DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                        DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                        this.state.godzina.godz1p.replace(':', ".")
                    )

                    RozkladService.getZrobRozkladDlaJednejTrasy(
                        this.state.trasa.idTr,
                        DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                        DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                        this.state.godzina.godz1p.replace(':', ".")
                    ).then(function (response) {



                        if (response.status < 300) {
                            this.refs.notificator.success('Pomyślnie wygenerowano rozkład', "", 3000)
                        } else {
                            this.refs.notificator.error('Wystąpił błąd przy próbie generowania', "", 3000)
                        }
                        this.setState({response: response})
                    }.bind(this)).catch(function (error) {

                        let czyIstnieje = (error.response.data.message.indexOf('Ten kurs ju')>-1)

                        this.refs.notificator.error('Wystąpił błąd przy próbie generowania', "", 3000)
                        this.setState({response:{data:[{info:'Wystąpił błąd krytyczny przy próbie generowania!'},{info:czyIstnieje? 'Ten kurs już istnieje!':'Nieznany błąd'}]}})
                    }.bind(this))

                }
            }
            else {
                // cąły dzien

                console.log(
                    this.state.trasa.idTr,
                    DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                    DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                    null
                )

                RozkladService.getZrobRozkladDlaJednejTrasy(
                    this.state.trasa.idTr,
                    DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                    DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                    ''
                ).then(function (response) {


                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie wygenerowano rozkład', "", 3000)
                    } else {
                        this.refs.notificator.error('Wystąpił błąd przy próbie generowania', "", 3000)
                    }
                    this.setState({response: response})
                }.bind(this)).catch(function (error) {
                    this.refs.notificator.error('Wystąpił błąd przy próbie generowania', "", 3000)
                    this.setState({response:{data:[{info:'Wystąpił błąd krytyczny przy próbie generowania!'}]}})
                }.bind(this))
            }
        }
    }


    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                        wartosc={option.status}
                                                                                                                        czyMarginesLewy={true}/></div>
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Form horizontal={true}>
                    <FormGroup>
                        <Col lg={4}>
                            <ControlLabel>Trasa <span className={'req'}>*</span></ControlLabel>
                            <TopSelect onChange={(e) => this.onChangeTrasa(e)} value={this.state.trasa} options={this.props.trasy}
                                       labelKey={'nazTr'} valueKey={'idTr'}
                                       optionRenderer={this.formatTrasaSelect} valueRenderer={this.formatTrasaSelect}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col lg={4}>
                            <div className={"add-label-margin"}></div>
                            <div>
                                <Radio name="radiogroupData" inline
                                       checked={(this.state.czyZakresDat)} onClick={() => {
                                    this.setState({czyZakresDat: true})
                                }}>
                                    Zakres dat
                                </Radio>
                                {' '}
                                <Radio name="radiogroupData" inline
                                       checked={(!this.state.czyZakresDat)} onClick={() => {
                                    this.setState({czyZakresDat: false, dataDo: this.state.dataOd})
                                }}>
                                    Dany dzień
                                </Radio>
                            </div>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        {
                            (this.state.czyZakresDat) ?
                                <Col lg={4}>
                                    <Row>
                                        <Col lg={6}>
                                            <ControlLabel>Od daty <span className={'req'}>*</span></ControlLabel>
                                            <TopInputDate onChange={(e) => this.setState({dataOd: e})} value={this.state.dataOd} horizontal={true}
                                                          minDate={moment(this.props.start)}
                                                          maxDate={moment(this.state.dataDo)}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <ControlLabel>Do daty <span className={'req'}>*</span></ControlLabel>
                                            <TopInputDate onChange={(e) => this.setState({dataDo: e})} value={this.state.dataDo} horizontal={true}
                                                          minDate={moment(this.state.dataOd)}
                                                          maxDate={moment(this.props.koniec)}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                :
                                <Col lg={4}>
                                    <Row>
                                        <Col lg={6}>
                                            <ControlLabel>Data <span className={'req'}>*</span></ControlLabel>
                                            <TopInputDate onChange={(e) => this.onChangePojedynczaData(e)} value={this.state.dataOd} horizontal={true}
                                                          minDate={moment(this.props.start)}
                                                          maxDate={moment(this.props.koniec)}
                                            />
                                        </Col>
                                        <Col lg={6}><Checkbox checked={this.state.czyKonkretnaGodzina}
                                                              onClick={() => this.setState({czyKonkretnaGodzina: !this.state.czyKonkretnaGodzina})}>Generowanie
                                            dla danej godziny</Checkbox>
                                            {
                                                (this.state.czyKonkretnaGodzina) ?
                                                    <TopSelect onChange={(e) => this.setState({godzina: e, czyByloSzukanie: false})}
                                                               value={this.state.godzina} options={this.props.godziny}
                                                               valueKey={'godz1p'} labelKey={'godz1p'}
                                                               disabled={(this.state.trasa === null || this.state.data === null)}
                                                    />
                                                    :
                                                    ''
                                            }

                                        </Col>
                                    </Row>
                                </Col>
                        }
                    </FormGroup>
                    <FormGroup>
                        <Col lg={4}>
                            <div>
                                <TopIf isTrue={!this.state.czyKonkretnaGodzina}>
                                    <TopAlertOstrzezenie
                                        text={"W przypadku generowania rozkładu dla danego całego dnia bądź zakresu dat nastąpi usunięcie starych kursów!"}/>
                                </TopIf>
                            </div>
                            <div className={'pull-right'}>
                                <div className={"add-label-margin"}></div>
                                <TopButtonAction
                                    onClick={() => this.onClickGeneruj()}
                                    iconType={"fa fa-table"}
                                    text={'Generuj rozkład jazdy'}
                                    btnSize={'md'}
                                />
                            </div>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col lg={12}>
                            {
                                Boolean(this.state.response) ?
                                    (this.state.response.data.length > 0) ?
                                        <div>
                                            <TopAlertUwaga text={"Wystąpił konflikt podczas próby generowania rozkładu"}/>
                                            <ul>
                                                {
                                                    this.state.response.data.map(item =>
                                                        <li>{item.info}</li>
                                                    )
                                                }
                                            </ul>
                                        </div>
                                        :
                                        <TopAlertSukces text={"Wygenerowano rozkład zgodnie z podanymi kryteriami"}/>
                                    :
                                ''
                            }
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/generujRozkladPojedynczo/components/GenerujRozkladForm.js